import React, { useEffect } from 'react';
import { useUserContext } from '../../context/user';
import Logo from "../../assets/logo.svg";
import { LayoutType } from "../../types/common/layout";

export const SelectLayout = () => {
    const { layout, setLayout } = useUserContext();

    const getLayoutName = (selectedLayout: LayoutType | null) => {
        if (selectedLayout === 'ADMIN') {
            return "Панель администратора";
        }
        if (selectedLayout === 'MANAGER') {
            return "Личный кабинет тревел-менеджера";
        }
        return "не определено";
    }

    const handleSelectLayout = (layout: LayoutType) => {
        setLayout(layout);
        window.location.replace('/')
    }

    useEffect(() => {
        console.log('handleSelectLayout layout, layout', layout)
    }, [layout]);

    useEffect(() => {
        console.log('handleSelectLayout will')
        handleSelectLayout('MANAGER')
    }, []);

    // NOTE: Disable layout 
    return (<div></div>)
    // NOTE: Disable layout 

    return (
        // Страница
        <div className="w-full min-h-dvh bg-gray-100 flex justify-center items-center">
            {/*MODAL*/}
            <div>
                <div className="flex flex-row items-center justify-center mb-12">
                    <img src={Logo} alt="" />
                </div>
                {/*CONTAINER*/}
                <div
                    className='flex justify-center items-center p-8 min-w-72 max-w-96 min-h-[16rem] rounded-lg bg-white text-xl font-medium'>
                    <div className="w-full">
                        <div
                            className="mb-8 font-manager-acrom-h4-24-medium-acrom
                            text-black
                            text-[length:var(--manager-acrom-h4-24-medium-acrom-font-size)]
                            text-center
                            ">
                            В какой сервис вы желаете зайти?
                        </div>

                        {layout && <div
                            className="
                            mb-8
                            text-sm
                            text-black
                            text-center
                            flex flex-col justify-center items-center gap-1
                            "
                        >
                            <div>Текущий сервис</div>
                            <div className='text-yellow-400'>{getLayoutName(layout)}</div>
                        </div>}

                        <div className="w-full flex flex-col justify-center items-center mt-4 gap-2">
                            <button
                                onClick={() => handleSelectLayout('MANAGER')}
                                className='
                                    hover:bg-yellow-400
                                    w-full h-12 inline-flex items-center justify-center flex-[0_0_auto]
                                    rounded-lg gap-2.5 p-8 relative
                                    text-center
                                    bg-melon-yellow'
                            >
                                {getLayoutName('MANAGER')}
                            </button>
                            <button
                                onClick={() => handleSelectLayout('ADMIN')}
                                className='
                                    hover:bg-yellow-400
                                    w-full h-12 inline-flex items-center justify-center flex-[0_0_auto]
                                    rounded-lg gap-2.5 p-8 relative
                                    text-center
                                    bg-melon-yellow'
                            >
                                {getLayoutName('ADMIN')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};
